import { render } from "./bolang.vue?vue&type=template&id=1a866c73&scoped=true"
import script from "./bolang.vue?vue&type=script&lang=js"
export * from "./bolang.vue?vue&type=script&lang=js"

import "./bolang.vue?vue&type=style&index=0&id=1a866c73&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a866c73"]])

export default __exports__